const getBalanceWithExpiryDate = (individual_balances) => {
  const elementWithNullExpiration = individual_balances.find(
    (element) => element.expiration_date != null
  )
  return elementWithNullExpiration ? elementWithNullExpiration.balance : 0
}

export { getBalanceWithExpiryDate }
